import { useState } from 'react'
import { Note, useCreateNote, useDeleteNote, usePaginateNotes, useUpdateNote } from '@hooks'
import { Scope } from '@utils'

type UseNotesResult = {
  notes: Note[]
  searchText: string
  scopes: Scope[]
  selectedContactId: string | undefined
  isLoading: boolean
  setSearchText: (text: string) => void
  setScopes: (scopes: Scope[]) => void
  setSelectedContactId: (contactId: string | undefined) => void
  addNote: (note: Note) => void
  updateNote: (note: Note) => void
  deleteNote: (note: Note) => void
}
// Hook principal pour gérer les notes
export const useNotes = (): UseNotesResult => {
  const [searchText, setSearchText] = useState('')
  const [scopes, setScopes] = useState<Scope[]>([Scope.PRIVATE]);
  const [selectedContactId, setSelectedContactId] = useState<string | undefined>(undefined);
  
  const { flatData: notes, isLoading } = usePaginateNotes({q: searchText, contactId: selectedContactId, scope: scopes.length === 1 ? scopes[0] : undefined});
  const { mutate: addNote } = useCreateNote();
  const { mutate: updateNote } = useUpdateNote();
  const { mutate: deleteNote } = useDeleteNote();

  return {
    notes,
    searchText,
    scopes,
    selectedContactId,
    isLoading,
    setSearchText,
    addNote,
    updateNote,
    deleteNote,
    setSelectedContactId,
    setScopes
  }
} 